module.exports = __webpack_public_path__ + "static/media/waitline.b139c226.png";